import { render, staticRenderFns } from "./BuscarPractica.vue?vue&type=template&id=8524f57a&scoped=true"
import script from "./BuscarPractica.vue?vue&type=script&lang=js"
export * from "./BuscarPractica.vue?vue&type=script&lang=js"
import style0 from "./BuscarPractica.vue?vue&type=style&index=0&id=8524f57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8524f57a",
  null
  
)

export default component.exports